import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import Button from '@srm/ui/button';
import { ActionTypes } from '@models/actions/ActionTypes';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocumentActionsService } from '@services/actions/DocumentActionsService';
import { ActionExecutorModel } from '@organisms/actions/ActionExecutorModel';

export type IExternalSearchBarActionControlProps = {
    docId: string;
};

const ExternalSearchBarActionControl = ({ docId }: IExternalSearchBarActionControlProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [actions, setActions] = useState<IBaseAction[]>([]);
    const [selectedAction, setSelectedAction] = useState<IBaseAction>();

    useEffect(() => {
        if (!docId) return;

        let cancelled = false;
        new DocumentActionsService()
            .fetchActionsExternalSearchBar(docId)
            .then((response) => {
                if (!cancelled) {
                    setActions(response.data ?? []);
                }
            })
            .catch((e) => {
                if (!cancelled) {
                    console.error('Не удалось загрузить действия externalSearchBar', e);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [docId]);

    if (!actions.length) {
        return null;
    }

    return (
        <>
            {selectedAction && (
                <ActionExecutorModel
                    type={ActionTypes.Document}
                    objId={docId}
                    action={selectedAction}
                    completeHandler={() => setSelectedAction(undefined)}
                    navigateFunc={navigate}
                    location={location}
                />
            )}
            {actions.map((act) => {
                const buttonStyle: React.CSSProperties = {};
                if (act.options?.buttonStyle?.backgroundColor) {
                    buttonStyle.backgroundColor = act.options.buttonStyle.backgroundColor;
                }
                if (act.options?.buttonStyle?.textColor) {
                    buttonStyle.color = act.options.buttonStyle.textColor;
                }

                return (
                    <Button
                        key={act.key}
                        data-testid={`external-search-bar-action-${act.key}`}
                        style={buttonStyle}
                        variant="light"
                        size="sm"
                        aria-label={act.displayName}
                        onClick={() => setSelectedAction(act)}
                    >
                        {act.displayName}
                    </Button>
                );
            })}
        </>
    );
};

export default ExternalSearchBarActionControl;
